import { httpRequest } from "../../http"

/**
 * Archive and unarchive an engagement (MPN-1533).
 *
 * Hits `/archived/`, NOT `/archive/`. The latter exists and does something entirely
 * different: it archives the engagement's campaigns and ad groups on the ad networks.
 * They are one character apart and one of them talks to Google, so the distinction is
 * worth stating everywhere it appears.
 *
 * Both actions are Super Admin only, enforced by the server. The UI hides the control
 * from everyone else, but that is courtesy rather than security.
 */
export class CommandSetEngagementArchived {
  async run(engagementId: number, archived: boolean) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/archived/`

    return await httpRequest<any>(url, { method: archived ? "POST" : "DELETE" })
  }
}
